import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getNetSales } from '../services/user'

const initialState = {
  Student_Characteristicsloading: false,
  Student_Characteristics: [],

  // Enrollmentloading: false,
  // Enrollment: [],

  School_And_Centersloading: false,
  School_And_Centers: [],

  Student_Grouploading: false,
  Student_Group: [],

  Student_Enrollment_By_Yearloading: false,
  Student_Enrollment_By_Year: [],

  Student_Enrollment_By_Gradeloading: false,
  Student_Enrollment_By_Grade: [],

  Student_Enrollment_Reportloading: false,
  Student_Enrollment_Report: [],

  At_A_Glance_Top_Tileloading: false,
  At_A_Glance_Top_Tile: [],

  Schools_Centers_Reportloading: false,
  Schools_Centers_Report: [],

  Authenticate_Usersloading: false,
  Authenticate_Users: [],

  Financial_top_tileloading: false,
  Financial_top_tile: [],

  Financial_Total_Revenue_piechartloading: false,
  Financial_Total_Revenue_piechart: [],

  Financial_Total_Expenses_piechartloading: false,
  Financial_Total_Expenses_piechart: [],

  Student_Characteristics_Lineloading: false,
  Student_Characteristics_Line: [],



}

export const fetchStudent_Characteristics = createAsyncThunk(
  'fetchStudent_Characteristics',
  async (Student_Characteristics, thunkAPI) => {
    Student_Characteristics = { ...Student_Characteristics, elasticQueryName: "Student_Characteristics" }
    const response = await getNetSales(Student_Characteristics);
    return response.data
  }
)

export const fetchSchool_And_Centers = createAsyncThunk(
  'fetchSchool_And_Centers',
  async (School_And_Centers, thunkAPI) => {
    School_And_Centers = { ...School_And_Centers, elasticQueryName: "School_And_Centers" }
    const response = await getNetSales(School_And_Centers);
    return response.data
  }
)

export const fetchStudent_Group = createAsyncThunk(
  'fetchStudent_Group',
  async (Student_Group, thunkAPI) => {
    Student_Group = { ...Student_Group, elasticQueryName: "Student_Group" }
    const response = await getNetSales(Student_Group);
    return response.data
  }
)

export const fetchStudent_Enrollment_By_Year = createAsyncThunk(
  'fetchStudent_Enrollment_By_Year',
  async (Student_Enrollment_By_Year, thunkAPI) => {
    Student_Enrollment_By_Year = { ...Student_Enrollment_By_Year, elasticQueryName: "Student_Enrollment_By_Year" }
    const response = await getNetSales(Student_Enrollment_By_Year);
    return response.data
  }
)

export const fetchStudent_Enrollment_By_Grade = createAsyncThunk(
  'fetchStudent_Enrollment_By_Grade',
  async (Student_Enrollment_By_Grade, thunkAPI) => {
    Student_Enrollment_By_Grade = { ...Student_Enrollment_By_Grade, elasticQueryName: "Student_Enrollment_By_Grade" }
    const response = await getNetSales(Student_Enrollment_By_Grade);
    return response.data
  }
)


export const fetchStudent_Enrollment_Report = createAsyncThunk(
  'fetchStudent_Enrollment_Report',
  async (Student_Enrollment_Report, thunkAPI) => {
    Student_Enrollment_Report = { ...Student_Enrollment_Report, elasticQueryName: "Student_Enrollment_Report" }
    const response = await getNetSales(Student_Enrollment_Report);
    return response.data
  }
)

export const fetchAt_A_Glance_Top_Tile = createAsyncThunk(
  'fetchAt_A_Glance_Top_Tile',
  async (At_A_Glance_Top_Tile, thunkAPI) => {
    At_A_Glance_Top_Tile = { ...At_A_Glance_Top_Tile, elasticQueryName: "At_A_Glance_Top_Tile" }
    const response = await getNetSales(At_A_Glance_Top_Tile);
    return response.data
  }
)

export const fetchSchools_Centers_Report = createAsyncThunk(
  'fetchSchools_Centers_Report',
  async (Schools_Centers_Report, thunkAPI) => {
    Schools_Centers_Report = { ...Schools_Centers_Report, elasticQueryName: "Schools_Centers_Report" }
    const response = await getNetSales(Schools_Centers_Report);
    return response.data
  }
)

export const fetchAuthenticate_Users = createAsyncThunk(
  'fetchAuthenticate_Users',
  async (Authenticate_Users, thunkAPI) => {
    Authenticate_Users = { ...Authenticate_Users, elasticQueryName: "Authenticate_Users" }
    const response = await getNetSales(Authenticate_Users);
    return response.data
  }
)

export const fetchFinancial_top_tile = createAsyncThunk(
  'fetchFinancial_top_tile',
  async (Financial_top_tile, thunkAPI) => {
    Financial_top_tile = { ...Financial_top_tile, elasticQueryName: "Financial_top_tile" }
    const response = await getNetSales(Financial_top_tile);
    return response.data
  }
)

export const fetchFinancial_Total_Revenue_piechart = createAsyncThunk(
  'fetchFinancial_Total_Revenue_piechart',
  async (Financial_Total_Revenue_piechart, thunkAPI) => {
    Financial_Total_Revenue_piechart = { ...Financial_Total_Revenue_piechart, elasticQueryName: "Financial_Total_Revenue_piechart" }
    const response = await getNetSales(Financial_Total_Revenue_piechart);
    return response.data
  }
)

export const fetchFinancial_Total_Expenses_piechart = createAsyncThunk(
  'fetchFinancial_Total_Expenses_piechart',
  async (Financial_Total_Expenses_piechart, thunkAPI) => {
    Financial_Total_Expenses_piechart = { ...Financial_Total_Expenses_piechart, elasticQueryName: "Financial_Total_Expenses_piechart" }
    const response = await getNetSales(Financial_Total_Expenses_piechart);
    return response.data
  }
)

export const fetchStudent_Characteristics_Line = createAsyncThunk(
  'fetchStudent_Characteristics_Line',
  async (Student_Characteristics_Line, thunkAPI) => {
    Student_Characteristics_Line = { ...Student_Characteristics_Line, elasticQueryName: "Student_Characteristics_Line" }
    const response = await getNetSales(Student_Characteristics_Line);
    return response.data
  }
)


export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(fetchStudent_Characteristics.fulfilled, (state, action) => {
      state.Student_Characteristics = action.payload;
      state.Student_Characteristicsloading = false;
    }).addCase(fetchStudent_Characteristics.pending, (state, action) => {
      state.Student_Characteristicsloading = true;
    })

    builder.addCase(fetchSchool_And_Centers.fulfilled, (state, action) => {
      state.School_And_Centers = action.payload;
      state.School_And_Centersloading = false;
    }).addCase(fetchSchool_And_Centers.pending, (state, action) => {
      state.School_And_Centersloading = true;
    })

    builder.addCase(fetchStudent_Group.fulfilled, (state, action) => {
      state.Student_Group = action.payload;
      state.Student_Grouploading = false;
    }).addCase(fetchStudent_Group.pending, (state, action) => {
      state.Student_Grouploading = true;
    })

    builder.addCase(fetchStudent_Enrollment_By_Year.fulfilled, (state, action) => {
      state.Student_Enrollment_By_Year = action.payload;
      state.Student_Enrollment_By_Yearloading = false;
    }).addCase(fetchStudent_Enrollment_By_Year.pending, (state, action) => {
      state.Student_Enrollment_By_Yearloading = true;
    })

    builder.addCase(fetchStudent_Enrollment_By_Grade.fulfilled, (state, action) => {
      state.Student_Enrollment_By_Grade = action.payload;
      state.Student_Enrollment_By_Gradeloading = false;
    }).addCase(fetchStudent_Enrollment_By_Grade.pending, (state, action) => {
      state.Student_Enrollment_By_Gradeloading = true;
    })

    builder.addCase(fetchStudent_Enrollment_Report.fulfilled, (state, action) => {
      state.Student_Enrollment_Report = action.payload;
      state.Student_Enrollment_Reportloading = false;
    }).addCase(fetchStudent_Enrollment_Report.pending, (state, action) => {
      state.Student_Enrollment_Reportloading = true;
    })

    builder.addCase(fetchAt_A_Glance_Top_Tile.fulfilled, (state, action) => {
      state.At_A_Glance_Top_Tile = action.payload;
      state.At_A_Glance_Top_Tileloading = false;
    }).addCase(fetchAt_A_Glance_Top_Tile.pending, (state, action) => {
      state.At_A_Glance_Top_Tileloading = true;
    })

    builder.addCase(fetchSchools_Centers_Report.fulfilled, (state, action) => {
      state.Schools_Centers_Report = action.payload;
      state.At_A_Glance_Top_Tileloading = false;
    }).addCase(fetchSchools_Centers_Report.pending, (state, action) => {
      state.At_A_Glance_Top_Tileloading = true;
    })


    builder.addCase(fetchAuthenticate_Users.fulfilled, (state, action) => {
      state.Authenticate_Users = action.payload;
      state.Authenticate_Usersloading = false;
    }).addCase(fetchAuthenticate_Users.pending, (state, action) => {
      state.Authenticate_Usersloading = true;
    })

    builder.addCase(fetchFinancial_top_tile.fulfilled, (state, action) => {
      state.Financial_top_tile = action.payload;
      state.Financial_top_tileloading = false;
    }).addCase(fetchFinancial_top_tile.pending, (state, action) => {
      state.Financial_top_tileloading = true;
    })

    builder.addCase(fetchFinancial_Total_Revenue_piechart.fulfilled, (state, action) => {
      state.Financial_Total_Revenue_piechart = action.payload;
      state.Financial_Total_Revenue_piechartloading = false;
    }).addCase(fetchFinancial_Total_Revenue_piechart.pending, (state, action) => {
      state.Financial_Total_Revenue_piechartloading = true;
    })

    builder.addCase(fetchFinancial_Total_Expenses_piechart.fulfilled, (state, action) => {
      state.Financial_Total_Expenses_piechart = action.payload;
      state.Financial_Total_Expenses_piechartloading = false;
    }).addCase(fetchFinancial_Total_Expenses_piechart.pending, (state, action) => {
      state.Financial_Total_Expenses_piechartloading = true;
    })
    builder.addCase(fetchStudent_Characteristics_Line.fulfilled, (state, action) => {
      state.Student_Characteristics_Line = action.payload;
      state.Student_Characteristics_Lineloading = false;
    }).addCase(fetchStudent_Characteristics_Line.pending, (state, action) => {
      state.Student_Characteristics_Lineloading = true;
    })
  }

})

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount } = counterSlice.actions

export default counterSlice.reducer